import { configureStore } from '@reduxjs/toolkit';
import projectsReducer from './projectsSlice';
import requestsReducer from './requestsSlice';
import brdToFrdReducer from './brdToFrdSlice';

export const store = configureStore({
  reducer: {
    projects: projectsReducer,
    requests: requestsReducer,
    brdToFrd: brdToFrdReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['your/action/type'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
});

export default store;
